import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http"
import { inject } from "@angular/core"
import { AuthService } from "../services/auth"
import { BehaviorSubject, catchError, filter, switchMap, take, throwError } from "rxjs"
import { shouldSkip } from "./helpers/should-skip.helper"

let isRefreshing = false;
const refreshTokenSubject = new BehaviorSubject<string | null>(null);

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService)
  const tokens = authService.load()
  const idToken = tokens.idToken;

  if (shouldSkip(req.url, req.method)) {
    return next(req)
  }
  
  if (!idToken) {
    return next(req);    // this should probably be a logout dispatch, but we will tackle that later
  }

  const authReq = idToken
    ? req.clone({ setHeaders: { Authorization: `${idToken}` } })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      
      if (error.status !== 401 || req.url.includes('refresh')) {
        return throwError(() => error);
      }

      const refreshToken = tokens.refreshToken 
      
      if (!refreshToken) {
        authService.logout();
        return throwError(() => error);
      }

      if (!isRefreshing) {
        isRefreshing = true;
        refreshTokenSubject.next(null);

        return authService.refreshToken(refreshToken).pipe(
          switchMap((response: any) => {
            isRefreshing = false;

            authService.setTokens({
              accessToken: response.accessToken,
              refreshToken: response.refreshToken,
              idToken: response.idToken
            });

            refreshTokenSubject.next(response.idToken);

            return next(
              req.clone({
                setHeaders: {
                  Authorization: `Bearer ${response.idToken}`
                }
              })
            );
          }),
          catchError(refreshError => {
            isRefreshing = false;
            authService.logout();
            return throwError(() => refreshError);
          })
        );
      }
      return refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token =>
          next(
            req.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`
              }
            })
          )
        )
      );
    })
  )
}
